export default __webpack_public_path__ + "static/media/card_2.4bda66b1.jpg";